module.exports = __webpack_public_path__ + "static/media/slow-creative-arrow-down.438c6bf2.svg";